import React from 'react'
import { Users, BriefcaseBusiness } from 'lucide-react'

type Experience = 'client' | 'provider'

interface ExperienceSwitcherProps {
  experience: Experience
  onChange: (next: Experience) => void
}

const brandLogo = '/logo.png'

const TABS: Array<{ id: Experience; label: string; icon: React.ReactNode }> = [
  {
    id: 'client',
    label: 'Clients',
    icon: <Users size={19} strokeWidth={1.5} />,
  },
  {
    id: 'provider',
    label: 'Professionals',
    icon: <BriefcaseBusiness size={19} strokeWidth={1.5} />,
  },
]

export default function ExperienceSwitcher({ experience, onChange }: ExperienceSwitcherProps) {
  return (
    <div className="xp-bar-shell">
      <a className="xp-brand-floating" href="https://app.eucamatch.com" aria-label="EUCA Match home">
        <img src={brandLogo} alt="EUCA Match" className="xp-brand-mark" />
      </a>
      <div className="xp-bar" role="tablist" aria-label="Select experience">
        {TABS.map((tab) => {
          const active = tab.id === experience
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(tab.id)}
              className={active ? 'xp-btn is-active' : 'xp-btn'}
            >
              <span className="xp-btn-inner">
                <span className="xp-icon" aria-hidden>{tab.icon}</span>
                <span className="xp-text">{tab.label}</span>
              </span>
              {active && <span className="xp-active-bar" aria-hidden />}
            </button>
          )
        })}
      </div>
    </div>
  )
}
